export interface iMsgBase {
  id: string,// ID zprávy v eKomunikaci

  subject?: string,//  předmět zprávy
  body?: string,//  text zprávy (může být null)
  deliveredAt: string,//  datum a čas doručení zprávy

  senderOrganizationName?: string
  senderOrganizationIco?: string
  senderUserFirstname?: string
  senderUserSurname?: string

  recipientOrganizationName?: string
  recipientOrganizationIco?: string

  objectExtId: string //  ID nadřízeného objektu (zakázky, DNS, rámcové dohody) zprávy (pro sestavení URI ke stažení přes REST API IENu a pro sestavení odkazu na zakázku/DNS/rámcovku ve zdrojovém systému)
  objectName: string//  název nadřízeného objektu (zakázky, DNS, rámcové dohody) zprávy (pro zobrazení v GUI)
  systemExtId: string //  ID resp. URL zdrojového systému (pro sestavení URI ke stažení přes REST API IENu)

  type: string // contract | marketing

  canReply?: boolean // TODO nepouzito, ridi se  odpovedi v actions
// TODO neni v response ale az po zpracovani
  attachmentCount: number
  readsCount: number

  incomingMessage?: string
  outgoingMessage?: string
  extType?: {
    code: string,
    name: string,
    id: string
  },
}

export interface iMsg extends iMsgBase {
  messageExtId: string
  // extType: {
  //     code: string,
  //     name: string,
  //     id: string
  // }
}

export interface iSubm extends iMsgBase {
  submissionExtId: string
  state: string
}

export interface iMsgRes extends iMsg {
  attachmentCount: number
  readsCount: number
  message: iMsg
}

export interface iSubmRes extends iSubm {
  submission: iSubm
}

export const MSG_TYPES = {
  CONTRACT: 'contract',
  MARKETING: 'marketing',
  OPERATING: 'operating'
}

export interface iMsgAttachment {
  id: string
  fileName: string
  fileSize: number
  extId: string,//  ID přílohy=souboru v externím systému (pro sestavení URI ke stažení přes REST API IENu)
  isDownloadable: boolean,//  zda lze přílohu stáhnout (pokud false, nenabízet v GUI akci/odkaz pro stažení)
}
